export default "__VITE_ASSET__CStaHtsn__"